import React from "react";

class NotificationsModal extends React.Component {
  render() {
    return (
      <div className="popup">
        <div className="popup-content">
          <div className="title">Are you sure?</div>
          <div className="details">This action cannot be undone.</div>
          <div className="options">
            <button
              className="popup-yes"
              onClick={() => this.props.popupYesAction()}
            >
              YES, {this.props.popupText}
            </button>
            <button
              className="popup-no"
              onClick={() => this.props.popupNoAction()}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default NotificationsModal;
